import { render } from "./InfiniteSelect.vue?vue&type=template&id=5f45249c&scoped=true"
import script from "./InfiniteSelect.vue?vue&type=script&lang=js"
export * from "./InfiniteSelect.vue?vue&type=script&lang=js"

import "./InfiniteSelect.vue?vue&type=style&index=0&id=5f45249c&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f45249c"]])

export default __exports__